import React from 'react';
import classNames from 'classnames';

import device from 'common/support/device';

import Image from 'components/common/Image';

import styles from './PageHeader.module.scss';

interface PageHeaderProps {
  imageSrc?: string | null;
  title?: string | null;
  description?: string | null;
  hideHeader?: boolean;
  isVideo?: boolean;
  logoSrc?: string | null;
}

const PageHeader = ({
  imageSrc = null,
  title = null,
  description = null,
  hideHeader = false,
  isVideo = false,
  logoSrc = null,
}: PageHeaderProps) => {
  return (
    <div
      className={classNames(styles.backgroundGradient, {
        [styles.animate]: !device.isSlowDevice,
        [styles.showHeader]: !hideHeader,
        [styles.hideHeader]: hideHeader,
      })}
    >
      {isVideo && (
        <div className={styles.headerBackground}>
          <video autoPlay muted id="headerVideo" width="1920px">
            <source src={imageSrc ?? undefined} type="video/mp4" />
          </video>
        </div>
      )}
      {!isVideo && (
        <Image
          alt="page header img"
          src={imageSrc}
          className={styles.headerBackground}
        />
      )}
      <div className={styles.backgroundGradient}>
        <div className="d-flex flex-row h-100 w-100">
          {!!logoSrc && (
            <Image
              alt="page logo"
              src={logoSrc}
              className={styles.headerLogo}
            />
          )}
          <div
            className={classNames(
              'd-flex',
              'flex-column',
              styles.headerText,
              logoSrc ? styles.headerTextWithLogo : '',
            )}
          >
            <span className={styles.headerTitle}>{title}</span>
            <span className={styles.headerDescription}>{description}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
